export default "__VITE_ASSET__12e9edc7__"